import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4402Model } from '../kymw4402.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { CoopInfo } from '../vo/coop-info.model';

// レスポンス構造
type GetCoopListResponse = {
  CoopCode: string;
  CoopName: string;
  PlanCoopName: string;
  CoopShortName: string;
}[];

/**
 * 会員生協一覧取得サービス
 * @export GetCoopListService
 * @class GetCoopListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCoopListService extends PlessJsonResponderSub<GetCoopListResponse> {
  model: KYMW4402Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCoopListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCoopListService
   */
  execute(model: KYMW4402Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('KYMW02getCoopList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCoopListService
   */
  success(data: GetCoopListResponse) {
    this.model.copyCoopList = data.map(
      _ => new CoopInfo(_.CoopCode, _.CoopName)
    );
    if (this.calbak) this.calbak();
  }
}
